import { Nullable } from "common/records";
import { CalculatedFinancingRecord } from "common/records/CalculatedFinancing";
import { RootState } from "common/reducers";
import { model } from "common/reducers/estimate.reducer";

/**
 * @param {RootState} state The RootState
 * @param {{financedAmount: number; financeOptionId: number}} props The financed amount and finance option ID to load from state.
 * @returns {Nullable<CalculatedFinancingRecord>} Calculated finance record matching the requested parameters.
 */
export const calculatedFinancing = (
  state: RootState,
  props: { financedAmount: number; financeOptionId: number },
): Nullable<CalculatedFinancingRecord> =>
  state.getIn([model, "calculatedFinancingByFinancedAmount", props.financedAmount, props.financeOptionId]);
